<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12" sm="12" md="12">
        <DateField
          :inputData.sync="entry.date"
          v-bind="getObject('date')"
          label="Data"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-card outlined shaped>
          <v-card-title class="py-2">
            <span class="text-h6">Item a ser transformado</span>
          </v-card-title>

          <v-card-text class="text-right">

            <ExitItemForm
              ref="exitItemForm"
              :entry="entry.exitMovementItemAttributes"
              :extraData="extraData"
              :readOnly="readOnly"
              :isEdit="isEdit"
            />

          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-card outlined shaped>
          <v-card-title class="py-2">
            <span class="text-h6">Item resultante</span>
          </v-card-title>

          <v-card-text class="text-right">

            <EntryItemForm
              ref="entryItemForm"
              :entry="entry.entryMovementItemAttributes"
              :exitMovementItem="entry.exitMovementItemAttributes"
              :extraData="extraData"
              :readOnly="readOnly"
              :isEdit="isEdit"
            />

          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Descrição"
          autocomplete="off"
          outlined
          :disabled="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue";
// import StorageTransferItemsIndex from "@models/storages/storage_transfers/exit_movement_items/index.vue";
import StorageNew from "@models/storages/new.vue"
import BaseUtil from "@shared_components/base_util.vue";
import gql from 'graphql-tag'
import ExitItemForm from "./exit_item_form.vue"
import EntryItemForm from "./entry_item_form.vue"


export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    // StorageTransferItemsIndex: StorageTransferItemsIndex,
    StorageNew: StorageNew,
    BaseUtil: BaseUtil,
    ExitItemForm: ExitItemForm,
    EntryItemForm: EntryItemForm,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};


</script>

<style scoped></style>
